(ns motorsaif.web.admin.entity
  (:require
   [motorsaif.time :as time]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.utils :as utils]
   [motorsaif.url :as url]
   [motorsaif.web.components :as c]
   [motorsaif.data-utils :as data-utils :refer [assoc-if-val]]
   [motorsaif.string :as string :refer [format]]
   [motorsaif.web.lib.form :as form]
   [motorsaif.validation :as validation]
   [reagent.core :as r]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   [motorsaif.web.admin.edit-business :as edit-business]))

(defn user-form []
  (let [{:keys [id]} @(subscribe [:route/parameters])
        user (data-utils/wrap-results @(subscribe [:admin-data :users id]))
        init-data {:user (-> (select-keys user [:db/id :user/name :user/email :user/handle
                                                :user/status]))}
        form-key :current-user-profile
        on-submit (fn [{:keys [new-data] :as all}]
                    (let [req {:type :PUT
                               :url "/api/account/profile"
                               :params {:data (assoc-in new-data [:user :db/id] id)}
                               :id :update-profile
                               :handler
                               (fn [{:keys [success ex-message] :as res}]
                                 (if success
                                   (rf/dispatch [:toast {:type "success"
                                                         :message "Profile saved!"}])
                                   (rf/dispatch
                                    [:toast {:type "error"
                                             :message (format "Failed to saved %s: " ex-message)}])))
                               :error-handler (fn [res]
                                                (println "Error creating"))}]
                      (rf/dispatch [:do-ajax req])))

        make-form-args
        {:schema validation/edit-profile
         ;; Does not handle valid values
         :change-watch #(dispatch [:reset-form form-key %])
         :on-submit {:valid on-submit
                     :invalid (fn [error]
                                (rf/dispatch
                                 [:toast {:type "error"
                                          :message (format "Error %s" error)}])

                                (println "Submit error " error))}
         :init-data init-data}
        {:keys [*data form-params input select] :as form-args}
        (form/make-form make-form-args)
        admin? @(subscribe [:is-admin?])]
    (fn []
      [:div.container
       [c/header-with-back
        "Edit User"
        {:subtitle
         [:span (:db/id user)]}]
       [:a.btn
        {:href (format "/api/admin/become-user/%s" (:db/id user))
         :target "_blank"
         ;; :on-click
         ;;         #(rf/dispatch [:admin-become-user (:db/id user)])
         }
        "Become"]
       (str init-data)
       [:form#profile.default
        form-params
        [:div.fields
         [select
          {:label "User Status"
           :placeholder "Stauts"
           :data [{:title "Verified"
                   :value :verified}
                  {:title "Unverified"
                   :value :unverified}]}
          [:user :user/status]]
         [input {:label "Username"
                 :helper "Unique username that only belongs to you"} [:user :user/handle]]
         [input {:label "Name"
                 :helper "Your real name"} [:user :user/name]]
         [input {:label "Email"} [:user :user/email]]
         [:br]
         [input {:label "Change Password"
                 :helper "Optionally change your password"
                 :type "password"} [:user :user/password]]
         [input {:label "Confirm Password "
                 :type "password"} [:user :user/password-confirm]]
         [:button.btn.secondary.full
          {:type "submit"}
          "Update Information"]]]])))

(defn root []
  (let [{:keys [table]} @(subscribe [:route/parameters])
        data (subscribe [:admin-data table])
        {:keys [id table]} @(subscribe [:route/parameters])]
    [:div
     (condp = table
       :businesses [edit-business/root]
       :users [user-form])]))
